import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { finalize, Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { AuthService } from 'src/app/membership/auth.service';
import { SpinnerService } from 'src/app/shared/services/spinner.service';

const links = [
  {
    heading: 'Dashboard',
    icon: 'dashboard',
    pages: [
      {
        title: 'Overview',
        link: '/home/page/overview',
        icon: 'overview',
      },
      {
        title: 'Financial',
        link: '/home/page/financial',
        icon: 'operational',
      },
      {
        title: 'Operational',
        link: '/home/page/operational',
        icon: 'operational',
      },
    ],
  },
  {
    heading: 'Operations',
    icon: 'manage_accounts',
    pages: [
      { title: 'Users', link: '/home/page/users', icon: 'group' },
      { title: 'Trips', link: '/home/page/trips', icon: 'flight' },
      {
        title: 'Shipments',
        link: '/home/page/shipments',
        icon: 'business_center',
      },
      {
        title: 'VIP Shipment',
        link: '/home/page/vip-shipment',
        icon: 'workspace_premium',
      },
      {
        title: 'Feedbacks',
        link: '/home/page/feedbacks',
        icon: 'feedback',
      },
      {
        title: 'Reported Issues',
        link: '/home/page/issues',
        icon: 'issues',
      },
      {
        title: 'Businesses',
        link: '/home/page/businesses',
        icon: 'business',
      },
    ],
  },
  {
    heading: 'Finance',
    link: '/home/page/finance',
    icon: 'account_balance',
    pages: [
      { title: 'Wallets', link: '/home/page/wallet-requests', icon: 'account_balance_wallet' },
      { title: 'Wallet Settings', link: '/home/page/wallet-settings', icon: 'settings' },
      { title: 'Payouts', link: '/home/page/payouts', icon: 'flight' },
      { title: 'Stripe Errors', link: '/home/page/stripe-errors', icon: 'error_outline' },
      { title: 'Transactions', link: '/home/page/transactions', icon: 'group' },
      { title: 'Currency Management', link: '/home/page/currencies', icon: '' }
    ],
  },
  {
    heading: 'Marketing',
    icon: 'campaign',
    pages: [
      {
        title: 'Ads',
        link: '/home/page/ads',
        icon: 'photo_library',
      },
      {
        title: 'Blogs',
        link: '/home/page/blogs',
        icon: 'people_outline',
      },
      {
        title: 'Promotions',
        link: '/home/page/promotions',
        icon: 'card_giftcard',
      },
      {
        title: 'Notifications',
        link: '/home/page/notifications',
        icon: 'notifications',
      },
      {
        title: 'Subscribers',
        link: '/home/page/subscribers',
        icon: 'people_outline',
      },
      {
        title: 'Testimonials',
        link: '/home/page/testimonials',
        icon: 'people_outline',
      },
    ],
  },
  {
    heading: 'Settings',
    icon: 'settings',
    pages: [
      {
        title: 'Prohibited Items',
        link: '/home/page/prohibited-items',
        icon: '',
      },
      {
        title: 'Legal Agreements',
        link: '/home/page/legal-agreements',
        icon: '',
      },
      {
        title: 'Weight Pricing',
        link: '/home/page/weight-pricing',
        icon: '',
      },
      {
        title: 'Referral Settings',
        link: '/home/page/referral-settings',
        icon: '',
      },
      {
        title: 'Reports',
        link: '/home/page/reports',
        icon: 'assessment',
      },
    ],
  },
];

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent {
  links = links;
  isHandset$: Observable<boolean> = this.breakpointObserver
    .observe(Breakpoints.Handset)
    .pipe(
      map((result) => result.matches),
      shareReplay()
    );

  constructor(
    private breakpointObserver: BreakpointObserver,
    private authService: AuthService,
    private router: Router,
    private spinnerService: SpinnerService,
    public titleService: Title
  ) { }

  logout(): void {
    this.spinnerService.showSpinner$.next(true);
    this.authService
      .logout()
      .pipe(finalize(() => this.spinnerService.showSpinner$.next(false)))
      .subscribe(() => this.router.navigate(['login']));
  }

  public isActive(navItem: any): boolean {
    return navItem.pages.find((el: any) => location.href.includes(el.link));
  }

  public getTitleWithoutPaquik(): string {
    const title = this.titleService.getTitle();

    return title.replace('Paquik |', '');
  }
}
